export const STORY_POINT_RANGES = [
  { value: 'none', label: 'Non estimé', shortLabel: '—', min: 0, max: 0 },
  { value: 'xs', label: 'Essentiel · 1–4 SP', shortLabel: '1–4', min: 1, max: 4 },
  { value: 's', label: 'Compact · 5–8 SP', shortLabel: '5–8', min: 5, max: 8 },
  { value: 'm', label: 'Standard · 9–12 SP', shortLabel: '9–12', min: 9, max: 12 },
  { value: 'l', label: 'Étendu · 13–20 SP', shortLabel: '13–20', min: 13, max: 20 },
  { value: 'xl', label: 'Complexe · 21–40 SP', shortLabel: '21–40', min: 21, max: 40 },
  { value: 'xxl', label: 'Hors norme · 41+ SP', shortLabel: '41+', min: 41, max: Infinity },
];

export const matchesStoryPointRanges = (points, selected) => {
  if (selected.size === 0) return true;
  const value = Number(points) || 0;
  return STORY_POINT_RANGES.some(range => selected.has(range.value) && value >= range.min && value <= range.max);
};

export const buildStoryPointRangeOptions = stories => STORY_POINT_RANGES
  .map(range => ({ ...range, count: stories.filter(story => {
    const value = Number(story.storyPoints) || 0;
    return value >= range.min && value <= range.max;
  }).length }))
  .filter(range => range.count > 0);

export const sortMilestoneOptionsByDeadline = (options, milestones = []) => {
  const deadlines = new Map(milestones.map(milestone => [milestone.name, milestone.deadline || milestone.date || null]));
  const today = Date.now();
  const distance = name => {
    const raw = deadlines.get(name);
    if (!raw) return Number.POSITIVE_INFINITY;
    const value = new Date(raw).getTime();
    return Number.isNaN(value) ? Number.POSITIVE_INFINITY : Math.abs(value - today);
  };
  return [...options].sort((a, b) => distance(a.name) - distance(b.name) || a.name.localeCompare(b.name, 'fr'));
};
